import DeleteOutlineRoundedIcon from "@mui/icons-material/DeleteOutlineRounded";
import { ActionIconButton } from "../../components/datatable/DataGridActions";

const columnsData = [
  {
    field: "full_name",
    headerName: "Mentor",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "mobile_no",
    headerName: "Mobile",
    flex: 1,
    minWidth: 110,
  },
  {
    field: "msg",
    headerName: "Message",
    flex: 1,
    minWidth: 140,
  },
];

let actionHeader = (handleDelete, setOpen, setSelectedRow) => {
  const actionColumn = [
    {
      field: "action",
      headerName: "Action",
      minWidth: 72,
      maxWidth: 90,
      sortable: false,
      align: "center",
      headerAlign: "center",
      renderCell: (params) => {
        return (
          <div className="cellAction cellAction--icons">
            <ActionIconButton
              title="Delete record"
              onClick={() => handleDelete(params.row.id)}
              color="error"
            >
              <DeleteOutlineRoundedIcon fontSize="small" />
            </ActionIconButton>
          </div>
        );
      },
    },
  ];
  return actionColumn;
};

const columnHeader = {
  columnsData,
  actionHeader,
};

export default columnHeader;
